import React from 'react';
import { AppBar, Toolbar, Typography, IconButton, Box, Menu, MenuItem, TextField, Tooltip } from '@mui/material';
import { Helmet } from 'react-helmet';
import SearchIcon from '@mui/icons-material/Search';
import MenuIcon from '@mui/icons-material/Menu';
import Advertisement from './Advertisement_2';  // Importiere die neue Advertisement-Komponente
import './Header.css';

const Header = ({ version, onSearch, setCurrentSection }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [searchOpen, setSearchOpen] = React.useState(false);
  const [searchQuery, setSearchQuery] = React.useState('');
  const [searchNotFound, setSearchNotFound] = React.useState(false);
  const [visitData, setVisitData] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [tooltipOpen, setTooltipOpen] = React.useState(false);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSearchClick = () => {
    setSearchOpen(!searchOpen);
    setSearchNotFound(false);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setSearchNotFound(false);
  };

  const handleSearchKeyPress = (event) => {
    if (event.key === 'Enter') {
      if (searchQuery.trim() === '') {
        setSearchOpen(false);
        setSearchNotFound(false);
      } else {
        const found = onSearch(searchQuery);
        if (!found) {
          setSearchNotFound(true);
        } else {
          setSearchOpen(false);
          setSearchNotFound(false);
        }
      }
    }
  };

  const fetchVisitData = () => {
    setIsLoading(true);
    fetch('https://api.open-source.org/api/getVisits')
      .then(response => response.json())
      .then(data => {
        setVisitData(data);
        setIsLoading(false);
      })
      .catch(error => {
        console.error('Error fetching visit data:', error);
        setVisitData(null);
        setIsLoading(false);
      });
  };

  React.useEffect(() => {
    fetchVisitData();  // Initial fetch when component mounts
  }, []);

  const handleTooltipOpen = () => {
    fetchVisitData();  // Fetch data when the tooltip is about to be shown
    setTooltipOpen(true);
  };

  const handleTooltipClose = () => {
    setTooltipOpen(false);
  };

  return (
    <>
      <Helmet>
        <title>Open-Source Explorer</title>
      </Helmet>

      <AppBar position="static" style={{ backgroundColor: '#aaccff', color: 'black' }}>
        <Toolbar style={{ display: 'flex', alignItems: 'center' }}>

          {/* ---------- LOGO & TOOLTIP ------------------------------------------------------------------------------------ */}
          <Box display="flex" alignItems="center" style={{ flexShrink: 0 }}>
            <Tooltip
              title={
                isLoading ? 'Loading visitors...' : visitData && typeof visitData !== 'string' ? (
                  <div>
                    <p>Daily: {visitData.daily}</p>
                    <p>Monthly: {visitData.monthly}</p>
                    <p>Yearly: {visitData.yearly}</p>
                    <p>Total: {visitData.total}</p>
                  </div>
                ) : 'Error loading visitors...'
              }
              arrow
              open={tooltipOpen}
              onOpen={handleTooltipOpen}
              onClose={handleTooltipClose}
            >
              <img src="/earth.svg" alt="Open-Source Explorer" className="rotating-logo" />
            </Tooltip>
          </Box>

          {/* ---------- TITLE ------------------------------------------------------------------------------------------------ */}
          <Box display="flex" flexDirection="column" alignItems="flex-start" style={{ marginLeft: '1rem' }}>
            <Typography variant="h6" style={{ marginBottom: '2px' }}>Open-Source Explorer</Typography>
            <Typography variant="subtitle2">{version}</Typography>
          </Box>

          {/* ---------- ADVERTISEMENT ------------------------------------------------------------------------------------ */}
          <Box style={{ flex: 1, textAlign: 'center' }}>
            <Advertisement />
          </Box>

          {/* ---------- SEARCH BUTTON & MENU ---------------------------------------------------------------------------- */}
          <Box display="flex" alignItems="center" style={{ marginLeft: 'auto' }}>
            {searchOpen && (
              <TextField
                variant="outlined"
                placeholder="Search..."
                size="small"
                value={searchQuery}
                onChange={handleSearchChange}
                onKeyPress={handleSearchKeyPress}
                style={{ marginRight: '10px' }}
                autoFocus
              />
            )}
            {searchNotFound && (
              <Typography variant="caption" style={{ color: 'red', marginRight: '10px' }}>
                Not found!
              </Typography>
            )}
            <IconButton onClick={handleSearchClick}>
              <SearchIcon />
              <Typography variant="caption">Search</Typography>
            </IconButton>
            <IconButton onClick={handleMenuOpen}>
              <MenuIcon />
              <Typography variant="caption">Menu</Typography>
            </IconButton>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
              <MenuItem onClick={() => { handleMenuClose(); setCurrentSection('dashboard'); }}>Dashboard</MenuItem>
              <MenuItem onClick={() => { handleMenuClose(); setCurrentSection('https://opensource.org'); }}>Open Source Initiative</MenuItem>
              <MenuItem onClick={() => {
                handleMenuClose();
                window.open('https://www.indiegogo.com/projects/join-the-future-of-open-source-org/x/38010214#/', '_blank');
              }}>
                Support Us
              </MenuItem>
              <MenuItem onClick={() => { handleMenuClose(); setCurrentSection('https://open-source.org/video/open-source.org.mp4'); }}>About Us</MenuItem>
            </Menu>
          </Box>

        </Toolbar>
      </AppBar>
    </>
  );
};

export default Header;
